(function ($) {
  $(function () {
    var siteHeader = document.querySelector('.site-header.is-sticky');
    var updateScroll = function () {
      if (siteHeader) siteHeader.classList.toggle('navbar-fixed-top', window.scrollY > 32);
      $('.scroll-to-top').toggleClass('show', window.scrollY > 150);
    };
    window.addEventListener('scroll', updateScroll, { passive: true });
    updateScroll();
    $('.scroll-to-top').on('click', function (event) {
      event.preventDefault();
      $('html, body').animate({ scrollTop: 0 }, 700);
    });

    // Separate buttons keep parent links usable by mouse, touch and keyboard.
    var desktopMenu = document.querySelector('#primary-menu');
    var closeDropdowns = function (except) {
      if (!desktopMenu) return;
      desktopMenu.querySelectorAll('li.is-open').forEach(function (item) {
        if (item === except || (except && item.contains(except))) return;
        item.classList.remove('is-open');
        item.querySelector(':scope > .submenu-toggle').setAttribute('aria-expanded', 'false');
      });
    };
    if (desktopMenu) {
      desktopMenu.querySelectorAll('li.menu-item-has-children').forEach(function (item, index) {
        var submenu = item.querySelector(':scope > .sub-menu');
        var link = item.querySelector(':scope > a');
        if (!submenu || !link) return;
        submenu.id = 'desktop-submenu-' + index;
        var toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'submenu-toggle';
        toggle.setAttribute('aria-label', link.textContent.trim() + ' \u2013 Untermen\u00fc');
        toggle.setAttribute('aria-controls', submenu.id);
        toggle.setAttribute('aria-expanded', 'false');
        link.after(toggle);
        var setOpen = function (open) {
          if (open) closeDropdowns(item);
          item.classList.toggle('is-open', open);
          toggle.setAttribute('aria-expanded', String(open));
        };
        toggle.addEventListener('click', function () { setOpen(!item.classList.contains('is-open')); });
        item.addEventListener('mouseenter', function () { setOpen(true); });
        item.addEventListener('mouseleave', function () {
          if (!item.contains(document.activeElement)) setOpen(false);
        });
        item.addEventListener('focusout', function () {
          window.setTimeout(function () {
            if (!item.contains(document.activeElement)) setOpen(false);
          }, 0);
        });
        item.addEventListener('keydown', function (event) {
          if (event.key === 'Escape' && item.classList.contains('is-open')) {
            event.stopPropagation();
            setOpen(false);
            toggle.focus();
          }
          if (event.key === 'ArrowDown' && (event.target === toggle || event.target === link)) {
            event.preventDefault();
            setOpen(true);
            submenu.querySelector('a').focus();
          }
        });
      });
      document.addEventListener('click', function (event) {
        if (!desktopMenu.contains(event.target)) closeDropdowns();
      });
    }

    // Native dialog handles the modal layer and keeps the page behind it inert.
    var mobileMenu = document.querySelector('#mobile-navigation');
    var menuButton = document.querySelector('.menu-btn-burger');
    if (!mobileMenu || !menuButton || typeof mobileMenu.showModal !== 'function') return;
    var mobileBreakpoint = window.matchMedia('(max-width: 1199px)');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var closeButton = mobileMenu.querySelector('.mobile-navigation-close');
    var root = document.documentElement;
    var scrollPosition = { x: 0, y: 0 };
    var closeTimer;
    var closing = false;
    var menuLocked = false;
    var backdropPointerDown = false;

    function closeMobileMenu(immediate) {
      if (!mobileMenu.open) return;
      closing = true;
      mobileMenu.classList.remove('is-visible');
      window.clearTimeout(closeTimer);
      function finishClose() {
        mobileMenu.close();
        resetMobileMenu();
      }
      if (immediate || reducedMotion.matches) finishClose();
      else closeTimer = window.setTimeout(finishClose, 220);
    }

    function resetMobileMenu() {
      if (!menuLocked) return;
      menuLocked = false;
      window.clearTimeout(closeTimer);
      closing = false;
      mobileMenu.classList.remove('is-visible');
      menuButton.setAttribute('aria-expanded', 'false');
      root.classList.remove('mobile-navigation-open');
      root.style.removeProperty('--mobile-navigation-scroll');
      window.scrollTo({ left: scrollPosition.x, top: scrollPosition.y, behavior: 'instant' });
      var focusTarget = menuButton.getClientRects().length ? menuButton : document.querySelector('.site-header .navbar-brand');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    }
    mobileMenu.addEventListener('close', function () { if (!mobileMenu.open) resetMobileMenu(); });
    menuButton.addEventListener('click', function () {
      if (!mobileBreakpoint.matches || mobileMenu.open) return;
      closeDropdowns();
      scrollPosition = { x: window.scrollX, y: window.scrollY };
      menuLocked = true;
      root.style.setProperty('--mobile-navigation-scroll', -scrollPosition.y + 'px');
      root.classList.add('mobile-navigation-open');
      mobileMenu.showModal();
      menuButton.setAttribute('aria-expanded', 'true');
      closeButton.focus({ preventScroll: true });
      window.requestAnimationFrame(function () {
        if (mobileMenu.open && !closing) mobileMenu.classList.add('is-visible');
      });
    });
    closeButton.addEventListener('click', function () { closeMobileMenu(false); });
    mobileMenu.addEventListener('cancel', function (event) {
      event.preventDefault();
      closeMobileMenu(false);
    });
    function outsidePanel(event) {
      var rect = mobileMenu.getBoundingClientRect();
      return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    }
    mobileMenu.addEventListener('pointerdown', function (event) { backdropPointerDown = outsidePanel(event); });
    mobileMenu.addEventListener('click', function (event) {
      if (backdropPointerDown && outsidePanel(event)) closeMobileMenu(false);
      backdropPointerDown = false;
      if (event.target.closest('a[href]')) closeMobileMenu(true);
    });
    mobileBreakpoint.addEventListener('change', function (event) {
      if (!event.matches) closeMobileMenu(true);
    });

    function setMobileSubmenu(item, open) {
      var submenu = item.querySelector(':scope > .sub-menu');
      var toggle = item.querySelector(':scope > .mobile-submenu-toggle');
      if (!submenu || !toggle) return;
      submenu.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      item.classList.toggle('is-expanded', open);
      if (!open) submenu.querySelectorAll('li.is-expanded').forEach(function (child) { setMobileSubmenu(child, false); });
    }
    mobileMenu.querySelectorAll('li.menu-item-has-children').forEach(function (item, index) {
      var submenu = item.querySelector(':scope > .sub-menu');
      var link = item.querySelector(':scope > a');
      if (!submenu || !link) return;
      submenu.id = 'mobile-submenu-' + index;
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'mobile-submenu-toggle';
      toggle.setAttribute('aria-label', link.textContent.trim() + ' \u2013 Untermen\u00fc');
      toggle.setAttribute('aria-controls', submenu.id);
      link.after(toggle);
      setMobileSubmenu(item, item.classList.contains('current-menu-ancestor') || item.classList.contains('current-menu-item'));
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') !== 'true';
        if (open) Array.from(item.parentElement.children).forEach(function (sibling) {
          if (sibling !== item) setMobileSubmenu(sibling, false);
        });
        setMobileSubmenu(item, open);
      });
    });
    mobileMenu.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var focusable = Array.from(mobileMenu.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]')).filter(function (element) {
        return element.getClientRects().length && !element.closest('[hidden], [inert]');
      });
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    root.classList.add('mobile-navigation-ready');
  });
})(jQuery);
